import { ACCESSION_MODES } from "./enums";

export function getModeRoute(mode, caseId) {
  switch (mode) {
    case ACCESSION_MODES.Specimen:
      return {
        name: "Specimen",
        params: { caseId }
      };
    case ACCESSION_MODES.Result:
      return {
        name: "SpecimenResults",
        params: { caseId }
      };
    case ACCESSION_MODES.Signout:
      return {
        name: "SpecimenResults",
        params: { caseId }
      };
    case ACCESSION_MODES.Transactions:
      return {
        name: "accesionTransactions",
        params: { caseId }
      };
    case ACCESSION_MODES.Insurance:
      return {
        name: "accessionInsurance",
        params: { caseId }
      };
    case ACCESSION_MODES.Distribution:
      return {
        name: "Distribution",
        params: { caseId }
      };
    case ACCESSION_MODES.History:
      return {
        name: "CaseHistory",
        params: { caseId }
      };
    case ACCESSION_MODES.AwaitingPathologist:
    case ACCESSION_MODES.AwaitingReviewer:
    case ACCESSION_MODES.AwaitingScreening:
      return {
        name: "CytologyResults",
        params: { caseId }
      };
    default:
      return {
        name: "CaseView",
        params: { caseId }
      };
  }
}
